module.exports = "/packs/media/images/logo-wealthfront-42a3c8f5de84a825043b7f47de21a210.png";